import { Component, OnInit, ViewChild, Renderer2, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { NoteService } from 'src/app/_services/dispo/note.service';
import { RentalService } from 'src/app/_services/cinema/rental.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.css']
})
export class NoteComponent implements OnInit, OnChanges {

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    if (changes['module_item_id']) {
      this.fetchData();
    }
  }

  public config: PerfectScrollbarConfigInterface = { wheelPropagation: true };
  @ViewChild(PerfectScrollbarComponent)
  componentRef?: PerfectScrollbarComponent;
  directiveRef?: PerfectScrollbarDirective;
  closeResult: string = '';
  noteList: any[] = [];
  currentUser: any;

  @Input() view : any;
  @Input() module_id : any;
  @Input() module_item_id : any;
  @Input('ngModel') description: any
  //@ViewChild(PerfectScrollbarDirective, { static: true })

   /**
 * Constructor
 * @param Renderer2                 renderer
 */
    constructor(
      private renderer: Renderer2,
      private modalService: NgbModal,
      private noteSerivce: NoteService,
      private router: Router,
      private route: ActivatedRoute
    ) {}

 
  ngOnInit(): void {
    //this.fetchData();
    if (localStorage.getItem('currentUser')) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }
  }

  onRouterOutletActivate(event) {
   this.fetchData();
  }

  convertToDate(unix) {
    const date = new Date(unix*1000);
    return date;
  }

  storeNote() {
    this.noteSerivce.store({module_id: this.module_id, module_item_id: this.module_item_id, description: this.description}).subscribe(
      data => {
        this.noteList = Array.isArray(data) ? data : [];
        this.description = "";
      },
      err => {
        console.error('Fehler beim Speichern der Notiz:', err);
        this.noteList = [];
      }
    );
  }

  fetchData() {
    this.noteSerivce.getModuleNote(this.module_id,this.module_item_id).subscribe(
      data => {
        this.noteList = Array.isArray(data) ? data : [];
      },
      err => {
        console.error('Fehler beim Laden der Notizen:', err);
        this.noteList = [];
      }
    );
  }

  deleteNote(noteId: number, note: any) {
    const message = this.getDeleteMessage(note);
    if (confirm(message)) {
      this.noteSerivce.softDelete(noteId).subscribe(
        data => {
          console.log('Lösch-Response:', data);
          if (data.success) {
            console.log('Löschung erfolgreich:', data.message);
            this.fetchData(); // Liste neu laden
          } else {
            console.error('Löschung fehlgeschlagen:', data.message);
          }
        },
        err => {
          console.error('Fehler beim Löschen der Notiz:', err);
        }
      );
    }
  }

  isNoteDeleted(note: any): boolean {
    return note && note.deleted_at !== null && note.deleted_at !== undefined;
  }

  isNoteWithin10Minutes(note: any): boolean {
    if (!note || !note.created_at) return false;
    
    try {
      const createdAt = new Date(note.created_at);
      const now = new Date();
      const diffInMinutes = Math.floor((now.getTime() - createdAt.getTime()) / (1000 * 60));
      
      return diffInMinutes <= 10;
    } catch (error) {
      console.error('Fehler beim Berechnen der Zeitdifferenz:', error);
      return false;
    }
  }

  getDeleteMessage(note: any): string {
    if (!note) return 'Möchten Sie diese Notiz wirklich löschen?';
    
    if (this.isNoteWithin10Minutes(note)) {
      return 'Möchten Sie diese Notiz wirklich löschen? (Wird endgültig gelöscht)';
    } else {
      return 'Möchten Sie diese Notiz wirklich löschen? (Wird als gelöscht markiert)';
    }
  }
}
